import { render, staticRenderFns } from "./EmployeeExternalRegistryFiles.vue?vue&type=template&id=0845c084&"
import script from "./EmployeeExternalRegistryFiles.vue?vue&type=script&lang=js&"
export * from "./EmployeeExternalRegistryFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports